import React from "react";

export default function IconSelect({ selected }) {
  return selected ? (
    <svg
      className="icon-selected"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Icon-Select-Selected</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-955.000000, -1299.000000)" fill="#4B4E6A">
          <g transform="translate(955.000000, 1299.000000)">
            <path d="M12,24 C5.37242975,24 0,18.6275702 0,12 C0,5.37242975 5.37242975,0 12,0 C18.6275702,0 24,5.37242975 24,12 C24,18.6275702 18.6275702,24 12,24 Z M8.04444444,12.2731313 C7.63757576,11.8917172 6.99838384,11.9123232 6.61656566,12.3191919 C6.23515152,12.7260606 6.25575758,13.3652525 6.66262626,13.7470707 L9.89494949,16.7773737 C10.3288889,17.1838384 11.0181818,17.129697 11.3830303,16.6606061 L17.04,9.38787879 C17.3822222,8.94747475 17.3030303,8.31313131 16.8626263,7.97050505 C16.4222222,7.62787879 15.7874747,7.70707071 15.4448485,8.14747475 L10.4686869,14.5458586 L8.04444444,12.2731313 Z" />
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      className="icon-select"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>Icon-Select</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
        <path d="M12,22.8 C17.9649553,22.8 22.8,17.9649553 22.8,12 C22.8,6.03546408 17.9649553,1.2 12,1.2 C6.03546408,1.2 1.2,6.03546408 1.2,12 C1.2,17.9649553 6.03546408,22.8 12,22.8 M8.11636364,12.2681653 L10.4965289,14.4995702 L15.3822149,8.21752066 C15.7186116,7.78512397 16.3418182,7.7073719 16.7742149,8.0437686 C17.2066116,8.38016529 17.2843636,9.00297521 16.9483636,9.4353719 L11.3942479,16.5758678 C11.0360331,17.0364298 10.3592727,17.0895868 9.93322314,16.6905124 L6.75966942,13.7153058 C6.36019835,13.3404298 6.33996694,12.7128595 6.71444628,12.3133884 C7.08932231,11.9139174 7.71689256,11.893686 8.11636364,12.2681653 M12,24 C5.37242975,24 0,18.6275702 0,12 C0,5.37242975 5.37242975,0 12,0 C18.6275702,0 24,5.37242975 24,12 C24,18.6275702 18.6275702,24 12,24" />
      </g>
    </svg>
  );
}
